import { render } from "./MainFooter.vue?vue&type=template&id=5ebb1ac2&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=5ebb1ac2&lang=scss&scoped=true"
import "./MainFooter.vue?vue&type=style&index=1&id=5ebb1ac2&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebb1ac2"]])

export default __exports__